if (!customElements.get('set-upgrade')) {
  class SetUpgrade extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.set-upgrade__checkbox');
      if (!this.checkbox) return;

      this.onCheckboxChange = this.onCheckboxChange.bind(this);
      this.checkbox.addEventListener('change', this.onCheckboxChange);
    }

    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.onCheckboxChange);
    }

    onCheckboxChange(event) {
      if (!event.target.checked) return;

      const toOptionValueId = this.dataset.toOptionValueId;
      const fromOptionValueId = this.dataset.fromOptionValueId;
      if (!toOptionValueId) return;

      const productInfo = this.closest('product-info');
      const variantSelects = productInfo?.querySelector('variant-selects');
      if (!productInfo || !variantSelects) return;

      const selectedOptionValues = this.getSelectedOptionValues(variantSelects, fromOptionValueId, toOptionValueId);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event: {
            target: this.checkbox,
          },
          target: this.checkbox,
          selectedOptionValues,
        },
      });
    }

    getSelectedOptionValues(variantSelects, fromOptionValueId, toOptionValueId) {
      const selectedOptionValues = Array.from(
        variantSelects.querySelectorAll('fieldset input:checked, select option[selected]')
      )
        .map(({ dataset }) => dataset.optionValueId)
        .filter(Boolean);

      const fromIndex = selectedOptionValues.indexOf(fromOptionValueId);
      if (fromIndex >= 0) {
        selectedOptionValues[fromIndex] = toOptionValueId;
        return selectedOptionValues;
      }

      return [toOptionValueId, ...selectedOptionValues];
    }
  }

  customElements.define('set-upgrade', SetUpgrade);
}
